// Faded target text with the student's typing laid over it: right = solid, wrong = red, caret at the next character.
export const TypingTargetText = ({ target, typed, dim = false, onClick }) => (
  <div
    className={`font-mono text-[15px] sm:text-base leading-7 whitespace-pre-wrap break-words text-left select-none cursor-text transition-opacity ${dim ? "opacity-50" : ""}`}
    onClick={onClick}
    data-testid="typing-target-text"
  >
    {Array.from(target).map((ch, i) => {
      const t = typed[i];
      const caret = i === typed.length;
      const tone = t === undefined ? "text-muted-foreground/45" : t === ch ? "text-foreground" : "text-red-600 dark:text-red-400 bg-red-500/15 rounded-sm";
      return (
        <span key={i} className={`relative ${tone} ${caret ? "before:content-[''] before:absolute before:-left-px before:top-1 before:h-5 before:w-0.5 before:bg-primary before:animate-pulse" : ""}`}>
          {ch === "\n" ? "↵\n" : ch}
        </span>
      );
    })}
  </div>
);
